import { Grid, Typography } from '@mui/material'
import ProjectCard from '../components/ProjectCard'
import PageShell from '../components/PageShell'
import { labProjects } from '../content/site'

const Lab = () => {
  return (
    <PageShell>
      <p className='section-eyebrow'>Experiments</p>
      <h1 className='section-heading'>The Lab</h1>
      <Typography className='section-lead' component='p'>
        Utilities and side projects that are not woodworking — but still worth keeping
        around.
      </Typography>
      <Grid container spacing={3}>
        {labProjects.map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project.id}>
            <ProjectCard
              title={project.title}
              description={project.description}
              tag={project.tag}
              to={project.path}
              placeholderLabel='Open tool'
            />
          </Grid>
        ))}
      </Grid>
    </PageShell>
  )
}

export default Lab
